import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/constants";

const PLACEHOLDER_COUNT = 3;

export default function Testimonials() {
  const hasReal = TESTIMONIALS.length > 0;

  return (
    <section id="testimoni" data-testid="testimonials-section" className="py-24 lg:py-40 border-t border-ink/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16 lg:mb-20 flex flex-wrap items-end justify-between gap-8"
        >
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand-ink mb-4">( Testimoni )</p>
            <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-5xl md:text-6xl lg:text-7xl">
              Testimoni <span className="font-serif italic normal-case text-brand-ink">pelanggan</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm text-ink/50 leading-relaxed">
            {hasReal
              ? "Apa kata pelanggan tentang layanan Sanjaya Service."
              : "Kami sedang mengumpulkan ulasan asli pelanggan. Bagian ini akan segera diperbarui."}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {hasReal
            ? TESTIMONIALS.map((t, i) => (
                <motion.figure
                  key={t.name}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.12 }}
                  data-testid={`testimonial-card-${i}`}
                  className="flex flex-col justify-between border border-ink/10 bg-white p-8 lg:p-10 hover:border-brand transition-colors duration-500"
                >
                  <div>
                    <Quote size={24} className="text-brand-ink mb-6" />
                    <blockquote className="text-base text-ink/75 leading-relaxed">“{t.quote}”</blockquote>
                  </div>
                  <figcaption className="mt-8 pt-6 border-t border-ink/10">
                    <p className="font-display font-bold">{t.name}</p>
                    <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-ink/40">{t.meta}</p>
                  </figcaption>
                </motion.figure>
              ))
            : Array.from({ length: PLACEHOLDER_COUNT }).map((_, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.12 }}
                  data-testid={`testimonial-placeholder-${i}`}
                  className="flex min-h-48 flex-col items-center justify-center gap-4 border border-dashed border-ink/20 p-8 text-center"
                >
                  <Quote size={24} className="text-ink/20" />
                  <p className="text-sm text-ink/40">Testimoni pelanggan akan ditampilkan di sini.</p>
                  <span className="rounded-full bg-ink/5 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-ink/35">
                    Placeholder
                  </span>
                </motion.div>
              ))}
        </div>
      </div>
    </section>
  );
}
